import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./index.css";
import ProtectedRoute from "./routes/ProtectedRoute";
import ConfirmAccount from './pages/ConfirmAccount';
import ForgotPassword from "./pages/ForgotPassword";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AplicatiiMembru from "./pages/AplicatiiMembru";
import Membri from "./pages/Membri";
import Voluntari from "./pages/Voluntari";
import Petitii from "./pages/Petitii";
import SettingsPage from "./pages/SettingsPage";
import { supabase } from "./supabaseClient";
import TrimiteMail from "./pages/TrimiteMail";
import TrimiteNewsletter from "./pages/TrimiteNewsletter";
import PRDPMembriPage from "./pages/PRDPMembri";
import CotizatieAdmin from "./pages/CotizatieAdmin";

function FullscreenLoader() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "#181932",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      fontFamily: 'Inter, Arial, sans-serif',
      fontSize: 22,
      letterSpacing: ".01em"
    }}>
      <img
        src="/logo192.jpg"
        alt="PRDP"
        style={{
          width: 84,
          height: 84,
          borderRadius: 18,
          marginBottom: 26,
          boxShadow: "0 8px 40px 0 rgba(1,40,130,0.16)"
        }}
        draggable={false}
      />
      <div style={{
        fontWeight: 700,
        fontSize: 22,
        marginBottom: 7,
        color: "#fff",
        textAlign: "center"
      }}>
        PRDP – Se încarcă preferințele de afișare...
      </div>
      <div style={{ color: "#8ca6d8", fontWeight: 400, fontSize: 15 }}>
        Vă rugăm așteptați
      </div>
    </div>
  );
};

const App = () => {
  // Dark mode default!
  const [darkMode, setDarkMode] = useState(true);
  const [loadingTheme, setLoadingTheme] = useState(true);

  useEffect(() => {
    // Aplicația va fi dark implicit
    let preferintaLocala = null;
    try {
      preferintaLocala = localStorage.getItem("darkMode");
    } catch { /* nimic */ }

    if (preferintaLocala !== null) {
      setDarkMode(preferintaLocala === "true");
    }

    // Dacă avem utilizator, preferința din profil are prioritate
    const fetchUserSettings = async () => {
      const {
        data: { user },
        error: userError
      } = await supabase.auth.getUser();

      if (user && !userError) {
        const { data, error } = await supabase
          .from('profiles')
          .select('dark_mode')
          .eq('id', user.id)
          .single();
        if (data && !error) {
          setDarkMode(!!data.dark_mode);
          try { localStorage.setItem("darkMode", data.dark_mode ? "true" : "false"); } catch {}
        }
      }
      setLoadingTheme(false);
    };

    fetchUserSettings();

    // Dacă nu există user, scoatem loaderul după scurt timp
    if (!preferintaLocala) setTimeout(() => setLoadingTheme(false), 200);
  }, []);

  useEffect(() => {
    if (darkMode) document.body.classList.add('dark');
    else document.body.classList.remove('dark');
    try { localStorage.setItem("darkMode", darkMode ? "true" : "false"); } catch {}
  }, [darkMode]);

  if (loadingTheme) {
    return <FullscreenLoader />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/confirm" element={<ConfirmAccount />} />
        <Route path="/set-password" element={<ConfirmAccount />} />
        <Route path="/reset-password" element={<ForgotPassword />} />
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/cereri-membru" element={
          <ProtectedRoute>
            <AplicatiiMembru />
          </ProtectedRoute>
        } />
        <Route path="/membri" element={
          <ProtectedRoute>
            <Membri />
          </ProtectedRoute>
        } />
        <Route path="/voluntari" element={
          <ProtectedRoute>
            <Voluntari />
          </ProtectedRoute>
        } />
        <Route path="/aplicatie-membri" element={
          <ProtectedRoute>
            <PRDPMembriPage />
          </ProtectedRoute>
        } />
        <Route path="/cotizatii" element={
          <ProtectedRoute>
            <CotizatieAdmin />
          </ProtectedRoute>
        } />
        <Route path="/petitii" element={
          <ProtectedRoute>
            <Petitii />
          </ProtectedRoute>
        } />
        <Route path="/trimite-mail" element={
          <ProtectedRoute>
            <TrimiteMail />
          </ProtectedRoute>
        } />
        <Route path="/trimite-newsletter" element={
          <ProtectedRoute>
            <TrimiteNewsletter />
          </ProtectedRoute>
        } />
        <Route path="/setari" element={
          <ProtectedRoute>
            <SettingsPage darkMode={darkMode} setDarkMode={setDarkMode} />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
};

export default App;
